"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _CloseOutlined = _interopRequireDefault(require("@ant-design/icons/CloseOutlined"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _useSheetDrag2 = require("../hooks/useSheetDrag");

require("../styles/sheet.less");

var styles = {
  "root": "meepshop-meep-ui__mobileLayout-sheet__root",
  "rootOpen": "meepshop-meep-ui__mobileLayout-sheet__rootOpen",
  "header": "meepshop-meep-ui__mobileLayout-sheet__header",
  "disableDrag": "meepshop-meep-ui__mobileLayout-sheet__disableDrag",
  "inner": "meepshop-meep-ui__mobileLayout-sheet__inner",
  "content": "meepshop-meep-ui__mobileLayout-sheet__content",
  "backdrop": "meepshop-meep-ui__mobileLayout-sheet__backdrop",
  "backdropOpen": "meepshop-meep-ui__mobileLayout-sheet__backdropOpen",
  "headerClose": "meepshop-meep-ui__mobileLayout-sheet__headerClose",
  "arrow": "meepshop-meep-ui__mobileLayout-sheet__arrow"
};

var Sheet = function Sheet(_ref) {
  var open = _ref.open,
      background = _ref.background,
      color = _ref.color,
      children = _ref.children,
      renderFooter = _ref.renderFooter,
      disableDrag = _ref.disableDrag,
      hideClose = _ref.hideClose,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '100svh' : _ref$height,
      _ref$contentClassname = _ref.contentClassname,
      contentClassname = _ref$contentClassname === void 0 ? '' : _ref$contentClassname,
      onClose = _ref.onClose,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? 1000 : _ref$zIndex;

  var _useSheetDrag = (0, _useSheetDrag2.useSheetDrag)({
    onClose: onClose,
    disabled: disableDrag,
    threshold: 100
  }),
      translateY = _useSheetDrag.translateY,
      handleStart = _useSheetDrag.handleStart;

  return /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(styles.backdrop, " ").concat(open ? styles.backdropOpen : ''),
    onClick: onClose,
    style: {
      zIndex: zIndex - 1
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(styles.root, " ").concat(open ? styles.rootOpen : ''),
    style: {
      zIndex: zIndex,
      background: background,
      color: color,
      fill: color,
      height: height === '100svh' ? '100svh' : "".concat(height + 48, "px"),
      transform: open ? "translateY(".concat(translateY, "px)") : 'translateY(100%)',
      transition: 'transform 0.3s ease'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(styles.header, " ").concat(disableDrag ? styles.disableDrag : ''),
    onMouseDown: handleStart,
    onTouchStart: handleStart
  }, !hideClose && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: styles.headerClose,
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(_CloseOutlined["default"], {
    width: 20,
    height: 20
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.inner
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(styles.content, " ").concat(contentClassname)
  }, children)), renderFooter)), document.querySelector('body'));
};

var _default = Sheet;
exports["default"] = _default;